type CategoryGrouping = {
  order: number;
  color: string;
};

// Hardcoded, should be agreed where to move it (ideally in CMS), it should be only temporary
export const getCategoryDataByName = (title: string): CategoryGrouping => {
  switch (title.toLocaleLowerCase()) {
    case 'digital creation':
      return { order: 1, color: '#00C896' };
    case 'digital research and problem-solving':
      return { order: 2, color: '#00C896' };
    case 'digital innovation':
      return { order: 3, color: '#00C896' };
    case 'digital learning':
      return { order: 4, color: '#FF7F41' };
    case 'digital teaching':
      return { order: 5, color: '#FF7F41' };
    case 'information literacy':
      return { order: 6, color: '#9569BE' };
    case 'data literacy':
      return { order: 7, color: '#9569BE' };
    case 'media literacy':
      return { order: 8, color: '#9569BE' };
    case 'digital communication':
      return { order: 9, color: '#FFC72C' };
    case 'digital collaboration':
      return { order: 10, color: '#FFC72C' };
    case 'digital participation':
      return { order: 11, color: '#FFC72C' };
    case 'digital identity management':
      return { order: 12, color: '#69B3E7' };
    case 'digital wellbeing':
      return { order: 13, color: '#69B3E7' };
    case 'digital proficiency':
      return { order: 14, color: '#E68699' };
    case 'digital productivity':
      return { order: 15, color: '#E68699' };
    case 'digital development':
      return { order: 5, color: '#FF7F41' };
    default:
      return { order: 16, color: '#003C3C' };
  }
};
